import React from 'react';
import {useDispatch} from "react-redux";

import SelectInput from "../../../Components/Inputs/SelectInput";
import { BOOKINGS_TABS } from "../Bookings";

const StatusSelector = (props) => {

    var options = (props.type === BOOKINGS_TABS.UPCOMING)
        ? [
            {
                label: 'All',
                value: 'all',
            },
            {
                label: 'Due Today',
                value: 'due',
            },
            {
                label: 'In Progress',
                value: 'in-progress',
            },
        ]
        : [
            {
                label: 'All',
                value: 'all',
            },
            {
                label: 'Departed',
                value: 'departed',
            },
            {
                label: 'No Show',
                value: 'no-show',
            },
            {
                label: 'Cancelled',
                value: 'cancelled',
            }
        ];

    const getValueOption = () => {
        if (typeof(props.value) == 'object') {
            return props.value;
        }

        if (options) {
            let selected = options.filter(option => option.value == props.value);

            if (selected.length > 0) {
                return selected[0];
            }
        }
        return null;
    }

    return (
        <SelectInput
            name={props.name}
            options={options}
            value={getValueOption()}
            onChange={props.onChange}
            classNamePrefix='filter-row-selector'
            menuPortalTarget={document.body}
        />
    )
}

StatusSelector.defaultProps = {
    name: 'status',
    type: BOOKINGS_TABS.UPCOMING
}

export default StatusSelector;
